/**
 * チュートリアルシステムデータサービス
 * システム配列からチュートリアル関連データを取得する機能を提供
 */
angular.module('inspinia').service('tutorialSystemDataService', [
  function () {
    /**
     * システム配列から値を取得するヘルパー関数
     * @param {Object} scope - スコープオブジェクト（system プロパティを持つ）
     * @param {string} arrayName - 配列名
     * @returns {Array|null} システム配列または null
     */
    this.getSystemArray = function (scope, arrayName) {
      return scope.system && scope.system[arrayName] && scope.system[arrayName][scope.tutorial.type]
        ? scope.system[arrayName][scope.tutorial.type]
        : null;
    };

    /**
     * システム配列から指定されたインデックスの値を取得
     * @param {Object} scope - スコープオブジェクト
     * @param {string} arrayName - 配列名
     * @param {number} index - インデックス
     * @returns {string|undefined} 取得した値
     */
    this.getSystemArrayValue = function (scope, arrayName, index) {

      const array = this.getSystemArray(scope, arrayName);
      return array && array[index];
    };

    return this;
  },
]);
